import { Component } from '@angular/core';

@Component({
  selector: 'app-sale-rackets',
  templateUrl: './sale-rackets.component.html',
  styleUrls: ['./sale-rackets.component.scss']
})
export class SaleRacketsComponent {
  rackets = [
    {
      name: 'Yonex Astrox 88D Pro',
      image: 'assets/images/racket1.jpg',
      condition: 'Mới giảm giá',
      originalPrice: 5200000,
      salePrice: 4290000,
      badge: '-18%'
    },
    {
      name: 'Lining Aeronaut 9000C',
      image: 'assets/images/racket2.jpg',
      condition: 'Vợt cũ',
      originalPrice: 3900000,
      salePrice: 2490000,
      badge: 'USED'
    },
    {
      name: 'Victor Thruster F',
      image: 'assets/images/racket3.jpg',
      condition: 'Mới giảm giá',
      originalPrice: 4100000,
      salePrice: 3290000,
      badge: '-20%'
    }
  ];
}